import { render, staticRenderFns } from "./freebackDialog.vue?vue&type=template&id=729688fd&scoped=true&"
import script from "./freebackDialog.vue?vue&type=script&lang=js&"
export * from "./freebackDialog.vue?vue&type=script&lang=js&"
import style0 from "./freebackDialog.vue?vue&type=style&index=0&id=729688fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729688fd",
  null
  
)

export default component.exports